import { TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TERMS } from "../../config/terminology";
import { setState,setTotalValues } from "./defineSlice";
import './Define.css'
import { formatNumber, removeComma } from "./defineUtils";

export default function TableCellWeek5(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered } = define;
   const [week5, setWeek5] = useState(params.row.weekly5);
   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;

   useEffect(()=>{
      setWeek5(params.row.weekly5);
   },[params.row.weekly5]);

   function updateGrid(hasError, w, quota) {
      if(quota !== w) {
         quota = w;
      }
      dispatch(setState("isFailed", true));
      dispatch(setState("isFailed_Info", `${TERMS.QUOTA} value has been updated as week 5 value was edited.`));
      let updatedItem = null;
      const updated = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               hasError,
               quota,
               weekly5: !w ? 0 : w,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < gridData.length; ++i) {
         const item = gridData[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }
      dispatch(setState("gridDataFiltered", updated));
      dispatch(setState("gridData", updatedGrid));
   }

   function updateWeek5(event) {
      let w5 = removeComma(event.target.value);
      w5 = Number(w5);
      let w4 = Number(params.row.weekly4);
      const quota = w5;
      let hasError = false;
      setWeek5(w5);
      if(!w5 && w5!==0) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
         return;
      }

      if(w4 > w5) {
         hasError = true;
      }
      dispatch(setState("gridDataChanged", true));
      updateGrid(hasError, w5, quota);
      dispatch(setTotalValues());
   }
   function handleValidity(w4, w5){
      if(w4 > w5) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must be greater or equal to Week4"));
      }
   }

   return (
      <TextField
         disabled={true}
         variant="standard"
         value={week5?.toLocaleString('en-US')}
         className={params.row.weekly5 !== params.row.quota ? 'red-row' : ''}
         onChange={updateWeek5}
         onBlur={() => {
            handleValidity(params.row.weekly4, params.row.weekly5);
         }}
         sx={{ width: 100 }}
         inputProps={{ style: {textAlign: 'center' } }}
      />
   );
}
